import Store from 'store'

const commitLabels = function(data) {
    if (data.labels && Object.keys(data.labels).length) {
        let labelsToCommit = data.labels

        if(data.labels.sortOptions){
            const sortOptions = JSON.parse(JSON.stringify(data.labels.sortOptions))
            let sortOptionLabels = {}

            if(sortOptions){
                sortOptionLabels = sortOptions.reduce((sortLabels,currentOption) => {
                    sortLabels[`sort-${currentOption.sortBy}-${currentOption.sortOrder}-label`] = currentOption.name
                    return sortLabels
                },{})
                labelsToCommit = Object.assign({},labelsToCommit,sortOptionLabels)
            }
        }
        

        Store.commit("main/setLabels", labelsToCommit)
    }
}

const richSnippetInfo = function(data) {
    if (data.productInfo && Object.keys(data.productInfo).length) {
        if(data.configuratorSettings.configuratorType == "Course" && data.configuratorSettings.applyStructuredData) {
            var courses = [];
            const [currency, ...rest] = data.configuratorSettings.priceFromText.split(' ');
            const lang = data.labels ? data.labels.languageCode : 'en'
            const price = parseFloat(rest.join('').replace(" ", "").replace(/\./g,'').replace(',','.'), 2);
            data.configuratorSettings.levelOne.forEach(course => {
                course.levelTwo.forEach(time => {
                    courses.push({
                        "@context": "https://schema.org/",
                        "@type": "Event",
                        "url": window.location.href,
                        "name": course.location + " | 🎓" + data.productInfo.title,
                        "description": data.productInfo.description.replace(/<(.|\n)*?>/g, ''),
                        "image": (window.location.protocol + '//' + window.location.hostname) + data.productInfo.imageUrl,
                        "startDate": new Date(time.date).toISOString().split('T')[0],
                        "endDate": new Date(time.endDate).toISOString().split('T')[0],
                        "eventAttendanceMode": "MixedEventAttendanceMode",
                        "eventStatus": "EventScheduled",
                        "location": {
                            "@type": "Place",
                            "name": course.location,
                            "address": {
                                "@type": "PostalAddress",
                                "addressLocality": course.location
                            }
                        },
                        "organizer": {
                            "@type": "Organization",
                            "name": "NTI",
                            "url": window.location.href
                        },
                        "performer": {
                            "@type": "Organization",
                            "name": "NTI"
                        },
                        "offers": {
                            "@type": "Offer",
                            "availability": {
                            "@type": "ItemAvailability",
                            "name": "Available"
                            },
                            "price": price,
                            "priceCurrency": currency,
                            "url": window.location.href
                        }
                    });
                })
            });
            var script = document.createElement('script');
            script.type = 'application/ld+json';
            script.append(JSON.stringify(courses));   

            document.head.appendChild(script);
        }
    }
}

const productInfo = function(data) {
    if (data.productInfo && Object.keys(data.productInfo).length) {
        const productInfoData = {
            canBeBought : data.productInfo.canBeBought,
            title : data.productInfo.title,
            description : data.productInfo.description,
            imageUrl : data.productInfo.imageUrl
        }
        Store.commit("main/setProductInfo", productInfoData)
    }

    if (data.tabs && Object.keys(data.tabs).length) {

        const productTabData = data.tabs.map((item, index) => {
            return {
                id : index+1,
                tabHeader : item.tabHeader,
                content : item.content,
                links : item.links,
                youtube : item.youtube,
                video : item.video
            }
        })
        Store.commit("main/setProductInfoTabs", productTabData)
    }
}

const productConfiguratorSettings = function(data) {
    if (data.configuratorSettings && data.configuratorSettings.configuratorType) {
        const productConfigData = {
            configuratorType : data.configuratorSettings.configuratorType,
            priceFromDiscountedText : data.configuratorSettings.priceFromDiscountedText,
            priceFromText : data.configuratorSettings.priceFromText,
            LevelOne: data.configuratorSettings.levelOne
        }
        Store.commit("main/setProductConfiguratorSettings", productConfigData)
    }
}

const relatedEntriesBanner = function(data) {
    if (!data.relatedBannerList) return;
    if (!(data.relatedBannerList.entries)) return;
    if (!(Object.keys(data.relatedBannerList.entries).length)) return;

    const entryBannerData = data.relatedBannerList.entries.map((item, index) => {
        return {
            id : index,
            header: item.header,
            title : item.title,
            priceText: item.priceText,
            link : item.link,
            buttonText: item.buttonText,
            imageUrl : item.imageUrl
        }
    })
    Store.commit("main/setRelatedCourseBanner", entryBannerData)
}

const relatedCollectionBanner = function(data) {
    if (data.relatedBannerList && data.relatedBannerList.collections && Object.keys(data.relatedBannerList.collections).length) {

        const collectionBannerData = data.relatedBannerList.collections.map((item, index) => {
            return {
                id : index,
                title : item.title,
                description : item.description,
                priceText: item.priceText,
                link: item.link,
                buttonText: item.buttonText,
                imageUrl : item.imageUrl
            }
        }) 
        Store.commit("main/setRelatedCollectionBanner", collectionBannerData)
    }
}

const promotedProductCards = function(data) {
    if (data.promotionCardList) {
        const promotedCardData = {
                bestsellersTitle : data.promotionCardList.bestsellersTitle,
                bestsellersList : data.promotionCardList.bestsellers,
                campaignsTitle : data.promotionCardList.campaignsTitle,
                campaignsList : data.promotionCardList.campaigns
            }
        Store.commit("main/setPromotedCards", promotedCardData)
    }
}

const commitPuidAndLang = function(data){
    const puid = data.labels ? data.labels.puid : '00000000-0000-0000-0000-000000000000'
    const lang = data.labels ? data.labels.languageCode : 'en'
    Store.commit('search/setPuid',puid)
    Store.commit('search/setLanguageCode',lang)
}

const preparePageData = function() {
    const el = '.nti-js--page-data'
    const DOM = document.querySelector(el)

    if (DOM) {
        const data = JSON.parse(DOM.textContent)
        commitLabels(data)
        productInfo(data)
        richSnippetInfo(data)
        productConfiguratorSettings(data)
        relatedEntriesBanner(data)
        relatedCollectionBanner(data)
        promotedProductCards(data)
        commitPuidAndLang(data)
    }
}

export default preparePageData